module.exports = __webpack_public_path__ + "fonts/font.7b9ab2d.woff";